import MuiTableCell from "@mui/material/TableCell";
const TableCell = MuiTableCell;
export default TableCell;
